import { render, staticRenderFns } from "./unit-quantities.vue?vue&type=template&id=a28aca3c&scoped=true&"
import script from "./unit-quantities.vue?vue&type=script&lang=js&"
export * from "./unit-quantities.vue?vue&type=script&lang=js&"
import style0 from "./unit-quantities.vue?vue&type=style&index=0&id=a28aca3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28aca3c",
  null
  
)

export default component.exports